











import { BlockLabel } from "@/models/BlockLabel";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ExistingMembershipExemption",
  props: {
    blockId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      displayName: BlockLabel.ExistingMembershipExemption,
    };
  },
  mounted() {
    this.$emit("updateBlock", {
      blockId: this.blockId,
      type: this.$options.name,
    });
  },
});
